import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/me/consolemode`;

export enum CONSOLE_MODE {
  NOT_SET = 'NotSet',
  SIMPLE = 'Simple',
  EXPERT = 'Expert',
}

interface SetMyUserConsoleModeForSellerCommandPayload {
  sellerId: string;
  consoleMode: CONSOLE_MODE;
}

const setMyUserConsoleModeForSellerCommand = async ({
  sellerId,
  consoleMode,
}: SetMyUserConsoleModeForSellerCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const response = await apiCall<BaseBackResponse | BackResponseFailure>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: { sellerId, consoleMode },
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default setMyUserConsoleModeForSellerCommand;
